import axios from 'axios';

// Pulls the best human-readable message out of an unknown error value. Tries,
// in order: an axios { message: ... } JSON body; an HTTP status + statusText
// from an axios response; a non-axios Error's .message; finally a generic
// fallback. Strips HTML response bodies — Express returns a default HTML 500
// page when the controller throws, and dumping that into the UI is worse
// than a one-line "500 Internal Server Error".
export function extractErrorMessage(err: unknown, fallback = 'Request failed',
  options: { verbatimMessage?: boolean } = {}): string {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    const statusText = err.response?.statusText;
    const data: unknown = err.response?.data;

    const objectMessage = data !== null && typeof data === 'object' && 'message' in data ? data.message : undefined;
    const message = typeof objectMessage === 'string' ? objectMessage : data;
    const htmlBody = typeof data === 'string' && data.trim().startsWith('<');
    if (typeof message === 'string' && message.trim() && !htmlBody) {
      return status && !options.verbatimMessage ? `${status} ${message}` : message;
    }

    if (status) {
      return statusText ? `${status} ${statusText}` : `HTTP ${status}`;
    }

    return err.message || fallback;
  }

  if (err instanceof Error) {
    return err.message || fallback;
  }

  return fallback;
}
